import { render, staticRenderFns } from "./customerVip.vue?vue&type=template&id=48ef1281&"
import script from "./customerVip.vue?vue&type=script&lang=js&"
export * from "./customerVip.vue?vue&type=script&lang=js&"
import style0 from "./customerVip.vue?vue&type=style&index=0&id=48ef1281&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports